import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const STATUS_COLORS = { testing: "#22D3EE", proven: "#2ECA7F", retired: "#64748B", rejected: "#F87171" };

export const ArchitectCard = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/mt5admin/brain/architect?limit=20").then((r) => setRows(r.data.strategies || [])).catch(() => {});
  }, []);
  return (
    <div data-testid="architect-card" className="mt-8 border border-[#22D3EE]/30 rounded-lg overflow-hidden bg-[#0B0D14]">
      <div className="px-5 py-3 border-b border-[#22D3EE]/30 flex items-center justify-between">
        <div className="text-lg font-medium">Strategy Architect</div>
        <div className="mono text-[10px] uppercase tracking-widest text-[#64748B]">Sonnet-designed rule sets · stress-tested cheaply</div>
      </div>
      {rows.length === 0 ? (
        <div className="p-6 mono text-xs text-[#64748B]">No designs yet - the architect fires when a symbol gets stuck.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full mono text-[11px] whitespace-nowrap">
            <thead>
              <tr className="text-[10px] uppercase tracking-widest text-[#64748B] border-b border-[#1F2937]">
                {["Code", "Symbol", "TF", "Name / idea", "Status", "Tests", "Best result"].map((h) => (
                  <th key={h} className="text-left px-3 py-2">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((s) => (
                <tr key={s.id} data-testid={`architect-row-${s.code}`} className="border-b border-[#111827] hover:bg-[#111827] transition-colors">
                  <td className="px-3 py-2 text-[#22D3EE]">{s.code}</td>
                  <td className="px-3 py-2">{s.symbol}</td>
                  <td className="px-3 py-2 text-[#94A3B8]">{s.period || "-"}</td>
                  <td className="px-3 py-2 max-w-[420px] truncate" title={s.idea || s.reject_reason}>
                    <span className="text-[#F1F5F9]">{s.name || "-"}</span>
                    <span className="text-[#64748B]"> · {s.idea || s.reject_reason}</span>
                  </td>
                  <td className="px-3 py-2" style={{ color: STATUS_COLORS[s.status] || "#94A3B8" }}>{s.status}</td>
                  <td className="px-3 py-2 text-[#94A3B8]">{s.tests || 0}/{(s.budget || 0) * (s.round || 1)}</td>
                  <td className="px-3 py-2 text-[#94A3B8]">{s.best_summary || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
